import React, { useEffect, useState } from "react";
import SideMenu from "../Pages/SideMenu";
import Header from "../Pages/Header";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import Footer from "../Pages/Footer";
import Logout from "../Pages/Logout";
import { Button } from "react-bootstrap";
import { CustomTable } from "../CustomTable";
import { getCropMasterAdd, getCropMasterGet, } from "../Utilities/URLCONSTANTS";
import axios from "axios";
import { CustomModal } from "../CustomModal";
import { GetApiHeaders } from "../Utilities/NetworkUtilities";
import Select from "react-select";
import { customStyles, formatRoleName, modalCustomStyles } from "../Utilities/utils";

export const CropMaster = () => {
    const [data, setData] = useState([]);
    const [showModal, setShowModal] = useState(false)
    const [name, setName] = useState()
    const [status, setStatus] = useState()
    const [id, setId] = useState()
    const [saveEdit, setSaveEdit] = useState()
    const [responseMsg, setResponseMsg] = useState()
    const [msgPopup, setMsgPopup] = useState(false)
    const [error, setError] = useState('')
    const [statusError, setStatusError] = useState('')
    const [loader, setLoader] = useState(false)
    const getData = async () => {
        const URL = getCropMasterGet;
        try {
            setLoader(true)
            const response = await axios.get(URL)
            setData(response.data.response)
            setLoader(false)
        } catch (error) {
            console.log(error)
        }
    }



    useEffect(() => {
        getData()
    }, [])

    const headersData = [
        {
            field: "name",
            header: "Crop ",
        },
        {
            field: "createdBy.firstName",
            header: "Created By",
        },
        {
            field: "status",
            header: "Status",
        },
    ];

    const onEditClicked = (data) => {
        setSaveEdit('Update')
        setId(data.id)
        setShowModal(true)
        setName(data.name)
        setStatus(data.status)
        setStatusError('')
        setError('')
    }

    const handleModalOpen = () => {
        setSaveEdit('Submit')
        setShowModal(true)
        setName('')
        setStatus('')
        setStatusError('')
        setError('')
    }
    const handleCancel_new = () => {
        setShowModal(false)
    }

    // const handleName = (e) => {
    //     const input = e.target.value;
    //     const alphabeticInput = input.replace(/[^a-zA-Z ]/g, "");
    //     setName(alphabeticInput)
    //     if (input) {
    //         setError('')
    //     }
    // }

    const handleName = (e) => {
        const input = e.target.value;
        const formattedInput = formatRoleName(input);
        setName(formattedInput);
        if (input) {
            setError('');
        }
    };

    const statusOptions = [
        { value: true, label: "Active" },
        { value: false, label: "In-Active" },
    ];

    const handleStatus = (selectedOption) => {
        setStatus(selectedOption?.value);
        console.log(" Status = " + selectedOption?.value);
        if (selectedOption) {
            setStatusError("");
        }
    };

    const handleSubmitData = async () => {
        if (status === "" || status === null || status === undefined) {
            setStatusError("Select Status")
        }

        if (!name) {
            setError('Enter Crop Name')
        }
        const apiUrl = getCropMasterAdd;
        const reqData = {
            id: saveEdit === "Submit" ? 0 : id,
            name: name,
            status: status
        }
        const headers = await GetApiHeaders()
        try {
            if (name !== '' && status !== '') {
                setLoader(true)
                const response = await axios.post(apiUrl, reqData, { headers })
                if (response.data.statusCode == 200 || response.data.status == 500) {
                    setShowModal(false)
                    setMsgPopup(true)
                    setResponseMsg(response.data.message);
                    setLoader(false)
                }
            }
        } catch (error) {
            console.log(error)
        }
    }
    const handleOk = () => {
        setMsgPopup(false)
        getData()
    }

    return (
        <body id="page-top">
            <div id="wrapper">
                <SideMenu />
                <div id="content-wrapper" className="d-flex flex-column">
                    <div id="content">
                        <Header />
                        <div>
                            <div className="container-fluid">
                                <div className="card border-0">
                                    <div className="card-body pt-0 pl-1">
                                        <h5 className="Roles_text">Master</h5>
                                        <div className="d-flex justify-content-between">
                                            <div>
                                                <h6 className="mb-0 Sub_role_text"> Crop Master</h6>
                                            </div>
                                            <span class="d-inline-block" tabindex="0" data-toggle="tooltip" title="Add Crop  Master"  >
                                                <Button variant="primary" className="buttons" onClick={handleModalOpen}  >
                                                    <FontAwesomeIcon icon={faPlus} className="plus_icon mr-1" />
                                                    Add
                                                </Button>
                                            </span>
                                        </div>
                                        <div className="mcrc_hrline"></div>
                                        <CustomTable
                                            headers={headersData}
                                            data={data}
                                            showAction={true}
                                            showButtons={true}
                                            ActionEdit={true}
                                            FileName={'Crop'}
                                            onEditClicked={onEditClicked}
                                            ActionName={"Action"}
                                            loader={loader}
                                        />

                                        <CustomModal
                                            showModal={showModal}
                                            handleCancel_new={handleCancel_new}
                                            tittle={'Crop Master'}
                                            buttonText={saveEdit}
                                            handleSubmitData={handleSubmitData}
                                            childrens={

                                                <div className="row align-items-start">
                                                    {/* Crop */}
                                                    <div className="col-md-6 col-12">
                                                        <label
                                                            htmlFor="cropName"
                                                            className="form-label text-sm font-weight-600"
                                                        >
                                                            Crop <span style={{ color: "red" }}>*</span>
                                                        </label>
                                                        <input
                                                            id="cropName"
                                                            type="text"
                                                            className="form-control"
                                                            style={{
                                                                height: "42px",
                                                                minHeight: "42px",
                                                            }}
                                                            maxLength={30}
                                                            placeholder="Enter Crop Name"
                                                            value={name}
                                                            onChange={handleName}
                                                        />
                                                        <span style={{ color: "red" }}>{error}</span>
                                                    </div>

                                                    {/* Status */}
                                                    <div className="col-md-6 col-12 " style={{ marginTop: "-2px" }}>
                                                        <label
                                                            htmlFor="statusDropdown"
                                                            className="form-label text-sm font-weight-600"
                                                        >
                                                            Status <span style={{ color: "red" }}>*</span>
                                                        </label>

                                                        <Select
                                                            inputId="statusDropdown"
                                                            styles={modalCustomStyles}
                                                            // className="mt-n1"
                                                            placeholder="Select Status"
                                                            isClearable
                                                            value={
                                                                [
                                                                    { value: true, label: "Active" },
                                                                    { value: false, label: "In-Active" },
                                                                ].find((option) => option.value === status) || null
                                                            }
                                                            options={[
                                                                { value: true, label: "Active" },
                                                                { value: false, label: "In-Active" },
                                                            ]}
                                                            onChange={(selectedOption) =>
                                                                handleStatus({
                                                                    value: selectedOption ? selectedOption.value : "",
                                                                })
                                                            }
                                                        />

                                                        <span style={{ color: "red" }}>{statusError}</span>
                                                    </div>
                                                </div>
                                            }
                                        />
                                        <CustomModal
                                            showModal={msgPopup}
                                            msgPopup={msgPopup}
                                            handleOk={handleOk}
                                            handleCancel_new={handleCancel_new}
                                            tittle={'Crop Master'}
                                            childrens={<div className="p-4 d-flex justify-content-center" style={{ fontSize: "18px", color: "#4A7729", fontWeight: 500 }}>{responseMsg}</div>}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <Footer />
                </div>
            </div>
            <a className="scroll-to-top rounded" href="#page-top">
                <i className="fas fa-angle-up"></i>
            </a>
            <Logout />
        </body>
    )
}